/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IAaaB2CContactUsData } from './aaa_b2c_contact_us.data';
import { IAaa_b2c_contact_usProps } from './aaa_b2c_contact_us.props.autogenerated';
import { contactusAsync, getB2BCustomerIdAsync } from '../../dataActions/DataActionExtension.g';

export interface IAaa_b2c_contact_usViewProps extends IAaa_b2c_contact_usProps<IAaaB2CContactUsData> {
    setFromField: any;
    onSubmit: any;
    state: any;
    stockistInfo: any;
    isLoginedIn: boolean;
}

/**
 *
 * Aaa_b2c_contact_us component
 * @extends {React.PureComponent<IAaa_b2c_contact_usProps<IAaaB2CContactUsData>>}
 */
class Aaa_b2c_contact_us extends React.PureComponent<IAaa_b2c_contact_usProps<IAaaB2CContactUsData>, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            firstName: '',
            lastName: '',
            email: '',
            phone: '',
            description: '',
            stockistInfo: {}
        };
        void this.getB2CStockistInfo();
    }
    private setFromField = (field: string, value: string) => {
        this.setState({ [field]: value });
    };
    private getB2CStockistInfo = async () => {
        const data = await getB2BCustomerIdAsync(
            { callerContext: this.props.context.actionContext },
            this.props.context.actionContext.requestContext.user.customerAccountNumber
                ? this.props.context.actionContext.requestContext.user.customerAccountNumber
                : ''
        );
        if (data.BMARetailStockist) {
            this.setState({ stockistInfo: data });
        }
    };
    private onSubmit = async () => {
        const payload = {
            FirstName: this.state.firstName,
            LastName: this.state.lastName,
            Email: this.state.email,
            Phone: this.state.phone,
            Description: this.state.description,
            Mobile: '',
            ReasonForContact: ''
        };
        await contactusAsync({ callerContext: this.props.context.actionContext, queryResultSettings: {} }, payload);
        this.setState({ firstName: '', lastName: '', phone: '', email: '', description: '' });
    };
    public render(): JSX.Element | null {
        const viewProps: IAaa_b2c_contact_usViewProps = {
            ...(this.props as IAaa_b2c_contact_usProps<IAaaB2CContactUsData>),
            setFromField: this.setFromField,
            state: this.state,
            onSubmit: this.onSubmit,
            stockistInfo: this.state.stockistInfo,
            isLoginedIn: this.props.context.actionContext.requestContext.user.isAuthenticated
        };
        return this.props.renderView(viewProps);
    }
}

export default Aaa_b2c_contact_us;
